const NOT_FOUND_STATUS = 404;

/**
 * Fetches a URL and converts the response to a base64 data URL using FileReader.
 * Resolves with null when the image no longer exists upstream.
 */
const toDataUrl = async (url: string): Promise<string | null> => {
  const res = await fetch(url);
  if (res.status === NOT_FOUND_STATUS) {
    return null;
  }

  const blob = await res.blob();
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error(`Failed to read blob for ${url}`));
    reader.readAsDataURL(blob);
  });
};

export default toDataUrl;
